<rask-page pageTitle="{{texts.title}}">
    <rask-container-block>
        <rask-span size="3"><a [href]="openApplicationInsights()" target="_blank">Övervakningssida Application Insight</a></rask-span>
        <div>
            <rask-checkbox [text]="texts.autoRefresh" [(ngModel)]="autoRefresh" (change)="onAutoRefreshChange($event)">
            </rask-checkbox>
        </div>
        <rask-schemalaggning-list currentSchemalaggningar="currentSchemalaggningar"></rask-schemalaggning-list>
    </rask-container-block>
</rask-page>
